import { render } from "./SecureChat.vue?vue&type=template&id=4ed41feb"
import script from "./SecureChat.vue?vue&type=script&lang=js"
export * from "./SecureChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__